<template>
    <div class="">
        <drawer 
            :title="addEditTitle" 
            :dialogShow="addEditShow" 
            @handleChange="handleChangeDrawer"
        >
            <div slot="body">
                <div class="pay-mains">
                    <el-form ref="form" :model="form" class="demo-ruleForm" label-width="121px">
                        <el-form-item label="客户姓名：">
                            {{ form.customerName }}
                        </el-form-item>
                        <el-form-item label="电话号码：">
                            {{ form.mobile }}
                        </el-form-item>
                        <el-form-item label="性别：">
                            {{ form.gender == 'male' ? '男' : '女' }}
                        </el-form-item>
                        <el-form-item label="修护金额：">
                            {{ form.amount }}
                        </el-form-item>
                        <el-form-item label="部位：">
                            {{ form.symptom }}
                        </el-form-item>
                        <el-form-item label="下次修护时间：">
                            {{ form.nextRepairTime }}
                        </el-form-item>
                        <el-form-item label="开卡日期：">
                            {{ form.recordTime }}
                        </el-form-item>
                        <el-form-item label="技师名称：">
                            {{ form.staffIdCn }}
                        </el-form-item>
                        <el-form-item label="备注：">
                            {{ form.remark }}
                        </el-form-item>
                    </el-form>
                </div>
                 <div class="drawer-footer">
                    <div class="btns">
                        <el-button type="danger" class="large-btn" @click="onSubmit">返回</el-button>
                    </div>
                </div>
            </div>
        </drawer>
    </div>
</template>

<script>
import minxin from '../../../assets/javascript/minxin.js'
import drawer from '../../../components/common/drawer'
export default {
    mixins: [minxin],
    components:{drawer},
    data () {
        return {
            addEditTitle: '',
            addEditShow: false,
            form: {
                mobile: '',
                gender: 'male',
                nextRepairTime: '',
                recordTime: '',
            },
            columns: [],
            staffList:[],
            cardOldName: '',
            showPicker: false,
        }
    },
    created(){
        this.editInit();
    },
    methods: {
        editInit(){
            this.$on('set',function(org){
                Object.assign(this.$data,this.$options.data());
                this.addEditTitle = '纸质修护卡详情';
                this.$api.get(this.$url.paperRepairDocument.get,{
                    id: org.id
                }).then( res => {
                    if(res){
                        this.form = res;
                        this.form.nextRepairTime = this.formatDay(this.form.nextRepairTime);
                        this.form.recordTime = this.formatDay(this.form.recordTime);
                        this.cardOldList();
                    }
                }).catch(error => {
    
                })
                this.addEditShow = true;
            })
            
        },
        handleChangeDrawer(){
            this.addEditShow = false;
            this.$emit('change',false);
        },
        onSubmit(values){
            this.addEditShow = false;
        },
    }
}
</script>
<style scoped lang="less">

/deep/ .el-input--small .el-input__inner{
    width: 200px;
    height: 40px;
    line-height: 40px;
}
/deep/ div .el-form-item--small .el-form-item__content, .el-form-item--small .el-form-item__label{
    line-height: 40px;
}
/deep/ .el-date-editor.el-input, .el-date-editor.el-input__inner{
    width: 200px;
}
.pay-mains{
    padding: 30px;
}
</style>